import { z } from '@hono/zod-openapi';

export const createKindnessChallengeEntryRequestSchema = z.object({
  slug: z
    .string()
    .optional()
    .openapi({ description: 'The slug of the kindness challenge' }),
  firstName: z
    .string()
    .min(1, { message: 'First name is required' })
    .openapi({ description: 'First name of the participant' }),
  lastName: z
    .string()
    .min(1, { message: 'Last name is required' })
    .openapi({ description: 'Last name of the participant' }),
  email: z
    .string()
    .email({ message: 'Please enter a valid email address' })
    .openapi({ description: 'Email address of the participant' }),
  phone: z
    .string()
    .min(1, { message: 'Phone number is required' })
    .openapi({ description: 'Phone number of the participant' }),
  socialHandle: z
    .string()
    .min(1, { message: 'Social handle is required' })
    .openapi({ description: 'Social handle (Instagram, TikTok, or Facebook)' }),
  socialPlatform: z
    .enum(['instagram', 'tiktok', 'facebook'], {
      errorMap: () => ({ message: 'Please select a social platform' })
    })
    .openapi({ description: 'Social platform for the handle' }),
  termsAccepted: z
    .literal(true, {
      errorMap: () => ({
        message: 'You must accept the terms and conditions'
      })
    })
    .openapi({ description: 'Whether the participant accepted the terms' }),
  anonymousId: z.string().optional().openapi({
    description: 'RudderStack anonymousId from the browser SDK'
  })
});

export const createKindnessChallengeEntryResponseSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.string().datetime()
});

export const kindnessChallengeFormSchema =
  createKindnessChallengeEntryRequestSchema.pick({
    slug: true,
    firstName: true,
    lastName: true,
    email: true,
    phone: true,
    socialHandle: true,
    socialPlatform: true,
    termsAccepted: true
  });

export const listKindnessChallengesResponseSchema = z.array(
  z.object({
    slug: z.string().openapi({ description: 'Challenge slug' }),
    displayName: z
      .string()
      .openapi({ description: 'Display name of the challenge' })
  })
);
